<template>
  <header>
    <div class="container">
      <div class="logo-side">
        <div
          :class="{ 'hidden-menu': true, 'hidden-menu_active': activeState }"
          @click="activeState = !activeState"
        >
          <IconActionsClose class="close" />
          <IconActionsMenu class="menu" />
        </div>

        <div class="header-logo">
          <a href="/">
            <IconLogoImage />
            <IconLogoText />
          </a>
        </div>
      </div>
      <nav>
        <ul>
          <li v-for="item in menu" :key="item.link">
            <a :href="item.link">{{ item.title }}</a>
          </li>
        </ul>
      </nav>
      <div class="header-buttons">
        <BaseButton to="/login" color="empty">
          <slot name="default">login</slot>
        </BaseButton>
        <BaseButton to="/book" color="filled" class="desktop">
          <slot name="default">Book a demo</slot>
        </BaseButton>
        <BaseButton to="/book" color="filled" class="hidden">
          <slot name="default">demo</slot>
        </BaseButton>
      </div>
    </div>
    <div :class="{ 'mobile-menu': true, 'mobile-menu_active': activeState }">
      <ul class="mobile-menu_center">
        <li v-for="item in menu" :key="item.link" @click="handleClose">
          <a :href="item.link">{{ item.title }}</a>
        </li>
      </ul>

      <ul class="mobile-menu_bottom">
        <li>
          <a :href="socials.instagram" target="_blank">
            <IconSocialsInstagram />
          </a>
        </li>
        <li>
          <a :href="socials.facebook" target="_blank">
            <IconSocialsFacebook />
          </a>
        </li>
        <li>
          <a :href="socials.linkedin" target="_blank">
            <IconSocialsLinkedin class="social-linkedin" />
          </a>
        </li>
        <li>
          <a :href="socials.twitter" target="_blank">
            <IconSocialsTwitter />
          </a>
        </li>
      </ul>
    </div>
  </header>
</template>

<style lang="scss">
header {
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #ffffff;
  padding: 12px 48px;
  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  @media screen and (max-width: 1540px) {
    padding: 12px 26px;
  }
  @media screen and (max-width: 1100px) {
    padding: 18px 32px;
  }
  @media screen and (max-width: 768px) {
    padding: 8px 16px;
  }
}

.logo-side {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.header-logo {
  a {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-decoration: none;
  }
  svg {
    &:nth-child(1) {
      width: 50px;
      height: 50px;
      margin-right: 14px;
      color: #40acff;
      @media screen and (max-width: 1380px) {
        width: 40px;
        height: 40px;
        margin-right: 12px;
      }

      @media screen and (max-width: 768px) {
        width: 30px;
        height: 30px;
        margin-right: 8px;
      }
    }
    &:nth-child(2) {
      width: 163px;
      height: 31px;
      color: #38317f;
      @media screen and (max-width: 768px) {
        width: 82px;
        margin-right: 8px;
      }
    }
  }
}

header nav {
  @media screen and (max-width: 1100px) {
    display: none;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  li {
    margin-right: 80px;
    &:last-child {
      margin-right: 0;
    }
    @media screen and (max-width: 1540px) {
      margin-right: 40px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  a {
    text-decoration: none;
    color: #202020;
    font-size: 22px;
    font-family: "Bebas Neue Pro";
    font-style: normal;
    font-weight: 700;
    letter-spacing: 2.2px;
    text-transform: uppercase;
    transition: all 0.3s;
    @media screen and (max-width: 1380px) {
      font-size: 18px;
    }

    &:hover {
      color: #878c95;
    }
    &:active {
      color: #40acff;
    }
  }
}

.header-buttons {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .hidden {
    @media screen and (min-width: 768px) {
      display: none;
    }
  }

  .desktop {
    @media screen and (max-width: 767px) {
      display: none;
    }
  }
  a {
    margin-left: 8px;
    &:last-child {
      margin-left: 0;
    }
  }
}

.hidden-menu {
  width: 40px;
  height: 40px;
  position: relative;
  overflow: hidden;
  margin-right: 16px;
  cursor: pointer;
  display: none;
  @media screen and (max-width: 767px) {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }

  @media screen and (max-width: 1100px) {
    display: block;
  }

  .close {
    width: 36px;
    height: 36px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    opacity: 0;
    transition: all 0.4s;

    @media screen and (max-width: 767px) {
      width: 24px;
      height: 24px;
    }
  }
  .menu {
    width: 36px;
    height: 36px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
    transition: all 0.4s;
    @media screen and (max-width: 767px) {
      width: 24px;
      height: 24px;
    }
  }

  &_active {
    .close {
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
    }
    .menu {
      transform: translate(-50%, -50%) scale(0);
      opacity: 0;
    }
  }
}

.mobile-menu {
  background-color: #ffffff;
  position: absolute;
  z-index: 3;
  top: 100%;
  left: -100%;
  width: 100%;
  min-height: calc(100svh - 82px);
  height: calc(100dvh - 82px);
  padding: 80px;
  align-items: center;
  align-content: space-between;
  flex-wrap: wrap;
  transition: all 0.3s;
  display: none;
  &_active {
    left: 0;
  }

  @media screen and (max-width: 1100px) {
    display: flex;
  }

  @media screen and (max-width: 768px) {
    min-height: calc(100svh - 58px);
    height: calc(100dvh - 58px);
    padding: 30px;
  }

  &_center {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    align-content: center;
    width: 100%;
    height: calc(100% - 82px);

    @media screen and (max-width: 768px) {
      height: calc(100% - 32px);
    }

    li {
      margin: 20px 0;
      width: 100%;
      text-align: center;
    }
    a {
      font-family: "Bebas Neue Pro";
      font-size: 22px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      letter-spacing: 3.3px;
      text-transform: uppercase;
      text-decoration: none;
      color: #202020;
      transition: color 0.4s;
      &:hover {
        color: #40acff;
      }
    }
  }

  &_bottom {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: center;

    li {
      margin: 0 24px;
    }

    svg {
      width: 32px;
      height: 32px;
      line-height: 0;
      fill: transparent;
      margin-bottom: 0 !important;

      path {
        fill: none;
        transition: all 0.5s;
      }
    }
    .social-linkedin g path {
      fill: #202020;
    }
  }
}
</style>

<script setup lang="ts">
import { menu, socials } from "../../utils/menu";
import BaseButton from "@/components/base/BaseButton.vue";
import IconSocialsInstagram from "@/components/icons/base/IconSocialsInstagram.vue";
import IconSocialsFacebook from "@/components/icons/base/IconSocialsFacebook.vue";
import IconSocialsLinkedin from "@/components/icons/base/IconSocialsLinkedin.vue";
import IconSocialsTwitter from "@/components/icons/base/IconSocialsTwitter.vue";
import IconActionsClose from "@/components/icons/base/IconActionsClose.vue";
import IconActionsMenu from "@/components/icons/base/IconActionsMenu.vue";
import IconLogoImage from "@/components/icons/base/IconLogoImage.vue";
import IconLogoText from "@/components/icons/base/IconLogoText.vue";
import { ref } from "vue";

const activeState = ref(false);

function handleClose() {
  activeState.value = false;
}
</script>
